export const DEV_MODE_TOKEN = 'devModeAuthToken'
